import React, { useRef, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const CustomPhoneInput = ({ formikProps, onChange, shouldFocus = false }) => {
    const phoneInputRef = useRef(null);

    useEffect(() => {
        if (shouldFocus && phoneInputRef.current) {
            // Focus the input when switching to phone mode
            const input = phoneInputRef.current.numberInputRef;
            if (input) {
                setTimeout(() => {
                    input.focus();
                    // Set cursor to end of input
                    const length = input.value.length;
                    input.setSelectionRange(length, length);
                }, 100);
            }
        }
    }, [shouldFocus]);

    return (
        <div>
            <PhoneInput
                ref={phoneInputRef}
                country={"pk"}
                disabled={false}
                disableDropdown={true}
                inputProps={{
                    name: "phone",
                    required: true,
                }}
                value={formikProps.values.phone}
                onChange={(value, countryData) => {
                    // Always force Pakistan country code
                    let processedValue = value;

                    // If someone pastes a different country code, convert it to Pakistan
                    if (value && !value.startsWith('92')) {
                        // Remove any existing country code and add Pakistan's
                        const numberPart = value.replace(/^\+?\d{1,4}/, '');
                        processedValue = '92' + numberPart;
                    }

                    // Ensure it always starts with 92
                    if (processedValue && !processedValue.startsWith('92')) {
                        processedValue = '92' + processedValue.replace(/^\+?92?/, '');
                    }

                    const phoneCode = "+92";
                    const phoneNum = processedValue.replace('92', '').trim();

                    formikProps.setFieldValue("phoneCode", phoneCode);
                    formikProps.setFieldValue("phoneNum", phoneNum);
                    formikProps.setFieldValue("phone", processedValue);

                    // Call the onChange callback if provided
                    if (onChange) {
                        // Only switch to email if the number part is completely empty
                        const numberOnly = processedValue.replace('92', '').trim();
                        onChange(processedValue, countryData, numberOnly);
                    }
                }}
                inputStyle={{
                    width: "100%",
                    fontSize: "16px",
                    padding: "4px",
                    paddingLeft: "48px",
                    backgroundColor: "#2d2d2d",
                    color: "#ffffff",
                    border: "1px solid #3d3d3d",
                    borderRadius: "4px",
                    height: "auto",
                }}
                buttonStyle={{
                    border: "none",
                    backgroundColor: "#2d2d2d",
                    borderRadius: "4px 0 0 4px",
                    padding: "0 6px",
                    cursor: "default",
                }}
                containerStyle={{
                    width: "100%",
                }}
                placeholder="3081234567"
            />
            <style>{`
        .react-tel-input .form-control {
          padding-left: 48px !important;
        }
        .react-tel-input .selected-flag {
          background-color: #2d2d2d !important;
          border-radius: 4px 0 0 4px !important;
          cursor: default !important;
        }
        .react-tel-input .selected-flag:hover,
        .react-tel-input .selected-flag:focus {
          background-color: #2d2d2d !important;
        }
        .react-tel-input .selected-flag .arrow {
          display: none !important;
        }
      `}</style>
            {formikProps.errors.phone && formikProps.touched.phone && (
                <div
                    style={{
                        color: "#ff4d4d",
                        fontSize: "12px",
                        marginTop: "5px",
                    }}
                >
                    {formikProps.errors.phone}
                </div>
            )}
        </div>
    );
};

export default CustomPhoneInput; 